import {APP_PREFIX} from './global';

export const AUTHENTICATION_KEY = APP_PREFIX + '_AUTH';
